import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useI18n } from 'hooks/useI18n';
import { StyledAnchor } from './MethodologyAnchor.styled';

const MethodologyAnchor: React.FC = () => {
  const { t } = useI18n('developer-career-report-2025');

  return (
    <StyledAnchor to="methodology" href="#methodology">
      <FontAwesomeIcon icon={faInfoCircle} />
      {t('mantechcar25.methodology-anchor')}
    </StyledAnchor>
  );
};

export default MethodologyAnchor;
